import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";

import { BfxPopupNotificationData } from "./bfx-popup-notification-data.model";
import { BfxPopupNotificationCommand } from "./bfx-popup-notification-command.enum";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";

export class BfxPopupTriggerNotificationData extends BfxPopupNotificationData {
  constructor(
    private activeUser: CubiqServices.ActiveUser,
    private hasReactivate: boolean,
    private hasFill: boolean,
    private slQuickFillEnabled: boolean,
    private traderGroupService: CubiqServices.TraderGroupLookupService,
  ) {
    super(BFXNotificationType.TRIGGERED, "icon-bfx_triggered");
    this.supportActionCallback = true;
  }

  protected updateAllowableActions() {
    let hasExternalOrderForFill: boolean = false;

    this.actions = [];
    if (this.hasFill || this.hasReactivate) {
      let quickFillCount: number = 0;
      let detailFillCount: number = 0;
      let reactivateCount: number = 0;
      this.payload.forEach((item) => {
        if (this.hasFill) {
          if (!hasExternalOrderForFill && item.deskId != null && typeof item.deskId === "string") {
            let traderGroup: CubiqTS.TradingGroupImpl = this.traderGroupService.getItem(
              item.deskId,
            );
            hasExternalOrderForFill = hasExternalOrderForFill || traderGroup.isExternallyFilledFg;
          }

          // Order is an SL order and quick fill is disabled for SL orders
          switch (item.requestedOrderType) {
            case CubiqTS.RequestOrderType.SL_ASK:
            case CubiqTS.RequestOrderType.SL_ATRATE:
            case CubiqTS.RequestOrderType.SL_BID:
            case CubiqTS.RequestOrderType.TSL_ASK:
            case CubiqTS.RequestOrderType.TSL:
            case CubiqTS.RequestOrderType.TSL_BID:
              if (this.slQuickFillEnabled) {
                quickFillCount++;
              }
              break;
            default:
              quickFillCount++;
              break;
          }
          detailFillCount++;
        }
        if (this.hasReactivate) {
          if (item.lockType === undefined) {
            if (
              this.activeUser.userTypeId === CubiqTS.UserType.ADMIN ||
              (this.activeUser.userTypeId === CubiqTS.UserType.TRADER &&
                this.activeUser.tradingGroupsIds.indexOf(item.as_fv_deskId) > -1) ||
              (this.activeUser.userTypeId === CubiqTS.UserType.SALES &&
                this.activeUser.salesGroupsIds.indexOf(item.as_fv_salesGroupId) > -1) ||
              (this.activeUser.userTypeId === CubiqTS.UserType.CLIENT &&
                this.activeUser.clientIds.indexOf(item.clientCode) > -1)
            ) {
              // Trader: owned by a Trader Group !'m a member of
              // Sales: client of a Sales Group I'm a member of
              // Admin: any
              // Client: for my clients
              reactivateCount++;
            }
          }
        }
      });

      if (quickFillCount == this.payload.length && !hasExternalOrderForFill) {
        this.actions.push({
          label: "Fill",
          command: BfxPopupNotificationCommand.POPUP_QUICK_FILL,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (detailFillCount == this.payload.length && !hasExternalOrderForFill) {
        this.actions.push({
          label: "Detail Fill",
          command: BfxPopupNotificationCommand.POPUP_DETAIL_FILL,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
      if (reactivateCount == this.payload.length) {
        this.actions.push({
          label: "Reactivate",
          command: BfxPopupNotificationCommand.POPUP_REACTIVATE,
          icon: "",
          styleClass: "bfx-context-menu-item-enabled",
        });
      }
    }
  }

  destroy() {
    this.activeUser = null;
    super.destroy();
  }
}
